import React, { useState, useEffect } from 'react';
import './Testimonials.css';

const Testimonials = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const testimonials = [
        {
            quote: "Over the past couple of years, I've been volunteering and I must say, I'm thankful for the experience and the chance to give back to my community.",
            author: "Anjana Bains",
            role: "Volunteer Since 2024"
        },
        {
            quote: "The quarterly donation drives are seamlessly organized. It's amazing to see how much we can achieve when the community comes together for a common cause.",
            author: "David M.",
            role: "Community Member"
        }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => 
                prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
            );
        }, 6000);
        return () => clearInterval(timer);
    }, [testimonials.length]);

    return (
        <section className="testimonials-section">
            <div className="container">
                <div className="testimonials-header">
                    <h2>Community Voices</h2>
                    <p>Hear from the passionate individuals who make our mission possible.</p>
                </div>

                <div className="testimonials-carousel">
                    {testimonials.map((testimonial, index) => (
                        <div 
                            key={index}
                            className={`testimonial-card ${index === currentIndex ? 'active' : ''}`}
                            aria-hidden={index !== currentIndex}
                        >
                            <svg className="quote-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                            </svg>
                            <blockquote className="testimonial-quote">
                                "{testimonial.quote}"
                            </blockquote>
                            <div className="testimonial-author">
                                <strong>{testimonial.author}</strong>
                                <span>{testimonial.role}</span>
                            </div>
                        </div>
                    ))}
                    
                    <div className="testimonial-dots" role="tablist">
                        {testimonials.map((_, index) => (
                            <button
                                key={index}
                                className={`t-dot ${index === currentIndex ? 'active' : ''}`}
                                onClick={() => setCurrentIndex(index)}
                                aria-label={`View testimonial ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
